import categoryType from '@/utils/constants/stipulation54CategoryType';

export default Object.freeze([
  {
    id: 1,
    name: categoryType.REGULAR,
  },
  {
    id: 2,
    name: categoryType.EDUCATIONAL,
  },
  {
    id: 3,
    name: categoryType.THERAPY,
  },
]);